import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
const { Title } = Typography;

function Shortcut({ title, link, details, style, onClick, level, tabIndex, className = "" }) {
  const { t } = useTranslation();
  return (
    <div style={style} className={`shortcut-container ${className}`}>
      <h2 className="shortcut-h2">{title}</h2>
      <div className="w-100 d-flex justify-content-end">
        {link && (
          <Link
            onClick={onClick}
            to={link}
            aria-label={`Scopri di più su ${title}`}
            tabIndex={tabIndex}>
            {details ? details : t('home.find_out_more')}
          </Link>
        )}
      </div>
    </div>
  );
}
export default Shortcut;
